/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorUnaryForGraph extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorUnaryForGraph");
    }

    getFixupPrototypeFunction() { return QueryOperatorUnaryForGraph.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorUnaryForGraph>): QueryOperatorUnaryForGraph {
        let obj = Object.assign(new QueryOperatorUnaryForGraph(), model);
        QueryOperatorUnaryForGraph.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorUnaryForGraph>): QueryOperatorUnaryForGraph {
        if (!model) return null;
        return QueryOperatorUnaryForGraph.newInstance(<QueryOperatorUnaryForGraph> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorUnaryForGraph) {
        if (!obj) return;

        models.QueryOperatorUnaryForGraph.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorUnaryForGraph): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorUnaryForGraph.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.a) {
            models.QueryOperator.fixupPrototype(this.a);
        }
    }

    /**
     * Sub-expression of the unary query operator
     */
    a: models.QueryOperator;

}
